<template>
    <div class="row">
        <div class="col-md-12">
            <small>Tags:</small>
            <span v-for="tag in tags.split(', ')"
                  class="label label-info">{{tag}}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'OrderTags',
    props: {
      tags: {
        required: true,
        type: String,
      },
    },
  };
</script>
